import { type ValuePathComponent, type ValuePathRoot } from "../traverseValue/ValuePath";

export function stringifyValueName(component: ValuePathRoot | ValuePathComponent) {
	let name: string | symbol | number;
	let stringify: (o: unknown) => string = String;
	switch (component.type) {
		case "Cell":
			name = component.cellName;
			break;
		case "ObjectField":
			name = component.key;
			break;
		case "ArrayElement":
			name = component.key;
			break;
		case "MapField":
			name = component.key;
			stringify = safeStringify;
			break;
		case "SetField":
			name = component.index;
			break;
	}

	return stringify(name);
}

const safeStringify = (o: unknown) => {
	try {
		return JSON.stringify(o);
	} catch (e) {
		return String(o);
	}
};
